



















import { defineComponent, PropType } from '@nuxtjs/composition-api';

type NotificationVariant = 'success' | 'error' | 'info';

export default defineComponent({
  name: 'InlineNotification',
  props: {
    variant: {
      type: String as PropType<NotificationVariant>,
      default: 'success'
    },
    messageMarkdown: {
      type: String,
      default: ''
    },
    notClosable: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
});
